import { render } from "./PessoaDetalhe.vue?vue&type=template&id=18b44797&scoped=true"
import script from "./PessoaDetalhe.vue?vue&type=script&lang=js"
export * from "./PessoaDetalhe.vue?vue&type=script&lang=js"

import "./PessoaDetalhe.vue?vue&type=style&index=0&id=18b44797&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b44797"]])

export default __exports__